import React,{useEffect,useRef} from 'react'
import gsap from "gsap";

const Pendulum = ({votes}) => {
const pendulumRef = useRef();
    const pivotRef = useRef();
    
    useEffect(() => {
      if (votes.bride > votes.groom) {
        gsap.to(pendulumRef.current.rotation, { z: -Math.PI / 6, duration: 1 });
      } else if (votes.groom > votes.bride) {
        gsap.to(pendulumRef.current.rotation, { z: Math.PI / 6, duration: 1 });
      } else {
        gsap.to(pendulumRef.current.rotation, { z: 0, duration: 1 });
      }
    }, [votes]);
  
    return (
      <group ref={pivotRef} position={[0, 2, 0]}>
        <mesh ref={pendulumRef} position={[0, -2, 0]}>
          <cylinderGeometry args={[0.1, 0.1, 4]} />
          <meshStandardMaterial color="gold" />
        </mesh>
      </group>
    );
}

export default Pendulum